<template>
  <div class="minW1060-auto bg-fff mag10 pad10">
    <el-row class="text-left">
		
      <div class="dlblock-mb20 mr10">
        <span class="pr5">姓名</span>
        <el-input v-model.trim="name" placeholder="请输入姓名" style="width: 150px;"/>
      </div>

     <div class="dlblock-mb20 mr10">
        <span class="pr5">楼层</span>
        <el-select v-model="floor" class="w150" clearable>
		  <el-option label="请选择" value=""/>
          <el-option label="一楼" value="一楼"/>
          <el-option label="二楼" value="二楼"/>
        </el-select>
      </div>

	  <div class="dlblock-mb20 mr10">
	    <span class="pr5">创建时间</span>
	    <el-date-picker
	        v-model="createTime"
	        style="width: 180px;"
	        type="datetime"
			class="reset-clear"
			:clearable="false"
			 unlink-panels
	        value-format="yyyy-MM-dd HH:mm:ss"
	        start-placeholder="开始日期"
	        />
	  </div> 
	  

	  	<div class="dlblock-mb20 mr10">
	    <span class="pr5">结束日期</span>
	    <el-date-picker
          v-model="updateTime"
		  style="width: 180px;"
          type="datetime"
          :clearable="false"
          unlink-panels
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
           />
	  </div> 

     <div class="dlblock-mb20 mr10">
        <span class="pr5">是否计算汇总</span>
        <el-select v-model="flagUp" class="w150" clearable>
           <el-option
            v-for="state in flagOptions"
                :key="state.key"
                :value="state.key"
                :label="state.name"
                 />
            </el-select>
      </div>

      <div class="dlblock-mb20 mr10">
        <el-button type="primary" @click="pages.page = 1; getCanteenSmsListPageFn()">
          搜索
        </el-button>
      </div>
	  

       <div class="dlblock-mb20 mr10">
	    <el-button type="primary" @click="editBtn(3)">
	      上传人脸识别日志一楼
	    </el-button>
	  </div>
	  
	  <div class="dlblock-mb20 mr10">
	      <el-button type="primary" @click="editBtn(4)">
	        上传人脸识别日志二楼
	      </el-button>
	    </div>

	  <div class="dlblock-mb20 mr10">
	    <el-button type="primary" @click="editBtn(5)">
	      日查看设置
	    </el-button>
	  </div>

    <div class="dlblock-mb20 mr10">
	    <el-button type="primary" @click="editBtn(6)">
	      导出
	    </el-button>
	  </div>

    </el-row>

    <el-table class="my-table" :data="tableData" v-loading="tableLoading" :header-row-class-name="'my-table-header'">
      <el-table-column align="center" prop="id" label="编号"></el-table-column>
	  <el-table-column align="center" prop="name" label="姓名"></el-table-column>
      <el-table-column align="center" prop="identificationNumber" label="内部编号"></el-table-column>
	  <el-table-column align="center" prop="comparisonTime" label="比对时间"></el-table-column>
	  <el-table-column align="center" prop="floor" label="楼层"></el-table-column>
	  <el-table-column align="center" prop="comparisonResults" label="比对结果"></el-table-column>
	  <el-table-column align="center" prop="documentType" label="证件类型"></el-table-column>
	  <el-table-column align="center" prop="faceDatabase" label="人脸库"></el-table-column>
	  <el-table-column align="center" prop="threshold" label="阈值"></el-table-column>
	  <el-table-column align="center" prop="fld" label="fid"></el-table-column>
      <el-table-column align="center" prop="similarity" label="相似度"></el-table-column>
     
     <!-- <el-table-column align="center" width="150" label="操作">
        <template slot-scope="{row}">
          <a class="glob-a"  @click="editBtn(2, row)">修改</a>
          <a class="glob-a"  @click="auditShow = {modal: true, data: row}">查看</a>
		   <a class="glob-a"  @click="editBtn(5, row)">删除</a>
        </template>
      </el-table-column> --> 
    </el-table>

    <div class="my-pagination">
      <el-pagination background layout="total, prev, pager, next" :total="pages.total"
                     :current-page="pages.page" @current-change="pageChange">
      </el-pagination>
    </div>


	<!-- 上传人脸识别日志一楼 -->
	  <el-dialog :title="faceRecognitionLog.add === 1 ? '上传人脸识别日志一楼' : '编辑'" :visible.sync="faceRecognitionLog.modal" width="500px">
	    <el-form label-width="150px">
	      <el-form-item label="文件：">
				<el-row>
				  <face-reco class="mr10 mb10" v-model="faceRecognitionLog.picture" :balance="balance" :total="1"/>
				</el-row>
	      </el-form-item>
	    </el-form>
	  </el-dialog>
	  
	  <!-- 上传人脸识别日志二楼 -->
	  <el-dialog :title="faceRecognitionLogTwo.add === 1 ? '上传人脸识别日志二楼' : '编辑'" :visible.sync="faceRecognitionLogTwo.modal" width="500px">
	    <el-form label-width="150px">
	      <el-form-item label="文件：">
	  				<el-row>
	  				  <face-reco class="mr10 mb10" v-model="faceRecognitionLogTwo.picture" :balance="12" :total="1"/>
	  				</el-row>
	      </el-form-item>
	    </el-form>
	  </el-dialog>


    <!-- 日查看设置 -->
    <el-dialog title="日查看设置" :visible.sync="friendData.modal"  width="400px">
      <el-form label-width="320px">
        <span class="pr5">时间</span>
	       <el-date-picker
	         v-model="timeSetting"
	         style="width: 280px;"
	         type="date"
	         value-format="yyyy-MM-dd"
	        />
      </el-form>

      <div slot="footer">
        <el-button @click="friendData.modal = false">取 消</el-button>
        <el-button type="primary" @click="getTransactionAndEntryTimeSetUpChangeFn()">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import {
    getTransactionAndEntryTimeSetUpSee,
    getTransactionAndEntryTimeSetUpChange,
	getListnhFaceRecognitionPage,
	
	addOrEditWordform,
	getEnwordMarkDelete,
	getEnWordInspect
  } from '@/api'

    //导出文件专用
   import {getListnhFaceRecognitionExport} from '@/api/indexUtil'

   import WordImg from '@/components/agriculturalBankFile.vue'
   import TransAction from '@/components/transactionFlowBankFile.vue'
   import FaceReco from '@/components/faceRecognitionLog.vue'

  export default {
	name: 'WordList',
	    components: {WordImg,TransAction,FaceReco},
    data () {
      return {
        flagUp:false,
        flagOptions:[{key: false, name: '不计算' },{key: true, name: '计算' }],
		//交易时间与入账时间设置查看日
        timeSetting:'',
        balance:10,
        name:'',
        phone:'',
        batch:'',
		createTime:'',
		updateTime:'',
		//楼层
		floor:'',
		word:'',
		chinese:'',
        userName: '',
        tableData: [],
        tableLoading: false,
        auditData: {
          modal: false,
          data: {},
          type: 'PASS',
          content: ''
        },
        auditShow: {
          modal: false,
          data: {}
        },
		//单词新增和修改
        editData: {
          modal: false,
          userId: '',
          add: 1,
          word: '',
          chinese: '',
          picture: []
        },
		//银行食堂上传交易流水
		canteen: {
          modal: false,
          userId: '',
          add: 1,
          word: '',
          chinese: '',
          picture: []
        },
     //银行食堂上传人脸识别日志一楼
		faceRecognitionLog: {
          modal: false,
          userId: '',
          add: 1,
          word: '',
          chinese: '',
          picture: []
        },
	//银行食堂上传人脸识别日志二楼
		faceRecognitionLogTwo: {
		     modal: false,
		     userId: '',
		     add: 1,
		     word: '',
		     chinese: '',
		     picture: []
		   },
        typeList: [],
        pages: {
          page: 1,
          total: 0
        },
		imgTotal: 1,
		// 图片上传
		imgUploadData: {
		  modal: false,
		  urlList: []
		},
		// 图片放大
		imgPreData: {
		  modal: false,
		  url: ''
		},
	   //交易流水统计早中晚合计笔数合计金额
        friendData: {
          modal: false,
          ratio: '',
          content: ''
        },
      }
    },
     watch: {
            // 如果 `question` 发生改变，这个函数就会运行
            balance: function () {               
                
            }
        },
    created () {
      //默认不计算汇总
      this.flag = this.flagOptions[0].name
      this.getCanteenSmsListPageFn()
    },
    methods: {
	//交易时间与入账时间月份查看设置
      getTransactionAndEntryTimeSetUpSeeFn(){
        this.tableLoading = true
        getTransactionAndEntryTimeSetUpSee({id:'02660e83-4173-424f-9d28-7086d47c6f52'}).then(res => {
          this.timeSetting = res.data;
        }).finally(() => {
          this.tableLoading = false
        })
      },
      //交易时间与入账时间月份查看设置 改变
      getTransactionAndEntryTimeSetUpChangeFn(){
        this.tableLoading = true
        getTransactionAndEntryTimeSetUpChange({id:'02660e83-4173-424f-9d28-7086d47c6f52',time:this.timeSetting}).then(res => {
          if(res.data){
             this.friendData = {
                modal: false,
                ratio: '',
                content: ''
              }
          }
        }).finally(() => {
          this.tableLoading = false
        })
      },
      getCanteenSmsListPageFn () {
        this.tableLoading = true
        getListnhFaceRecognitionPage({
          pageNum: this.pages.page,
          createTime: this.createTime,
		  updateTime: this.updateTime,
		  floor:this.floor,
          name: this.name,
          phone: this.phone,
          batch:this.batch,
          flagUp:this.flagUp
        }).then(res => {
          this.tableData = res.data.records
          this.pages.total = res.data.total
        }).finally(() => {
          this.tableLoading = false
        })
      },
      getListnhFaceRecognitionExportFn(){
         this.tableLoading = true
        getListnhFaceRecognitionExport({
          pageNum: this.pages.page,
          createTime: this.createTime,
		      updateTime: this.updateTime,
		      floor:this.floor,
          name: this.name,
          phone: this.phone,
          batch:this.batch,
          flagUp:this.flagUp
        }).then(res => {
            this.downloadFile(res)
        }).finally(() => {
          this.tableLoading = false
        })
      },
      // 文件下载导出
        downloadFile(res) {
        let url = window.URL.createObjectURL(new Blob([res.data]));
        let link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        link.setAttribute('download', '人脸识别记录.xls');
        document.body.appendChild(link);
        link.click()
      },
	  getEnwordMarkDeleteFn (id) {
	    this.tableLoading = true
	    getEnwordMarkDelete(id).then(res => {
	     this.$message.success(res.msg)
	     this.getCanteenSmsListPageFn()
	    }).finally(() => {
	      this.tableLoading = false
	    })	},
	  editBtn(t,row) {
		  //1新增 2修改 3列表查看图片 4查看里面的图片放大 5删除 6图片检查并下载
		  if(t == 1){
        //上传用户余额发送短信通知
			 this.editData = {
			   modal: true,
			   userId: '',
			   add: 1,
			   word: '',
			   chinese: '',
			   picture: []
			 }
		  }else if(t == 2){
        //上传银行食堂交易流水
			  console.info(row,"上传银行食堂交易流水")
			  this.canteen = {
			   modal: true,
			   userId: '',
			   add: 1,
			   word: '',
			   chinese: '',
			   picture: []
			  }
		  }else if(t == 3) {
        //上传人脸识别日志一楼
	     this.faceRecognitionLog = {
			   modal: true,
			   userId: '',
			   add: 1,
			   word: '',
			   chinese: '',
			   picture: []
			  }
	    }else if(t == 4) {
		//上传人脸识别日志二楼	
	   this.faceRecognitionLogTwo = {
	   			   modal: true,
	   			   userId: '',
	   			   add: 1,
	   			   word: '',
	   			   chinese: '',
	   			   picture: []
	   			  }
	    }else if(t == 5){
		  //交易流水统计早中晚合计笔数合计金额
	      this.friendData = {
                modal: true,
                ratio: '',
                content: ''
              }
        this.getTransactionAndEntryTimeSetUpSeeFn();
		}else if(t == 6){
      //导出excel
        this.$confirm(`确认导出人脸识别日志吗`, '提示', {
			    confirmButtonText: '确定',
			    cancelButtonText: '取消',
			    type: 'warning'
			  }).then(() => {
			     this.getListnhFaceRecognitionExportFn();
			});	
		}
	},
	addBtn (t) {
	  if (this.editData.add == 1) {
	    addOrEditWordform({
	      word: this.editData.word,
	      chinese: this.editData.chinese,
	      picture: this.editData.picture[0]
	    }).then(res => {
	      this.editData.modal = false
	      this.$message.success(res.data)
	      this.getCanteenSmsListPageFn()
	    })
	  } else {
	    addOrEditWordform({
	      id: this.editData.id,
	      word: this.editData.word,
	      chinese: this.editData.chinese,
	      picture: this.editData.picture[0]
	    }).then(res => {
	      this.editData.modal = false
	      this.$message.success(res.data)
	      this.getCanteenSmsListPageFn()
	    })
	  }
	},
	uploadSave() {
	  if (this.imgUploadData.urlList && this.imgUploadData.urlList.length) {
	    addImage(this.imgUploadData.urlList.map(item => ({pictureUrl: item}))).then(res => {
	      this.$message.success(res.data)
	      this.imgUploadData.modal = false
	      this.getImagePageFn()
	    })
	  }
	},
      pageChange (val) {
        this.pages.page = val
        this.getCanteenSmsListPageFn()
      }
    }
  }
</script>

<style scoped>
  .production-imgs img {
    width: 150px;
    height: 100px;
    margin-right: 15px;
    margin-bottom: 10px;
  }

  .type-ul {
    margin-top: 10px;
    max-height: 400px;
    overflow: auto;
  }

  .type-li {
    display: flex;
    align-items: center;
    line-height: 40px;
    border-bottom: 1px solid #d0d3da;
  }

  .type-li p {
    width: 80%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
</style>
